export const data = [
  {
    id: 0,
    name: "Faizan Rajab",
    phone: "03001234567",
    email: "faizan@email.com",
    amount: 20000,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "I owe to others",
  },
  {
    id: 1,
    name: "Mehroz Ali",
    phone: "03001234577",
    email: "mehroz@email.com",
    amount: 20001,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "I owe to others",
  },
  {
    id: 2,
    name: "Farhan",
    phone: "03001234577",
    email: "farhan@email.com",
    amount: 20002,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "I owe to others",
  },
  {
    id: 3,
    name: "Usama Ikram",
    phone: "03001234597",
    email: "usama@email.com",
    amount: 20004,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "I owe to others",
  },
  {
    id: 4,
    name: "Irfan Malik",
    phone: "03001234597",
    email: "irfan@email.com",
    amount: 200010,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "I owe to others",
  },
  {
    id: 5,
    name: "Umer",
    phone: "03001234597",
    email: "umer@email.com",
    amount: 200010,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "I owe to others",
  },
];

export const data_ = [
  {
    id: 0,
    name: "Faizan Rajab",
    phone: "03001234567",
    email: "faizan@email.com",
    amount: 20000,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "Others owe to me",
  },
  {
    id: 1,
    name: "Mehroz Ali",
    phone: "03001234577",
    email: "mehroz@email.com",
    amount: 20001,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "Others owe to me",
  },
  {
    id: 2,
    name: "Farhan",
    phone: "03001234577",
    email: "farhan@email.com",
    amount: 20002,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "Others owe to me",
  },
  {
    id: 3,
    name: "Usama Ikram",
    phone: "03001234597",
    email: "usama@email.com",
    amount: 20004,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "Others owe to me",
  },
  {
    id: 4,
    name: "Irfan Malik",
    phone: "03001234597",
    email: "irfan@email.com",
    amount: 200010,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "Others owe to me",
  },
  {
    id: 5,
    name: "Umer",
    phone: "03001234597",
    email: "umer@email.com",
    amount: 200010,
    reason: "Many Reasons",
    paidDate: "09/11/2020",
    dueDate: "09/11/2020",
    status: "PAID",
    loanType: "Others owe to me",
  },
];
